import { AHText, ListItem } from "arkh";
import { graphql, useFragment } from "react-relay";
import { useIntlTokens } from "../../components/mobile/useIntlTokens";
import { DateTime } from "luxon";
import { ProductExpireBatchListItemAction } from "../ProductExpireBatchListItem/ProductExpireBatchListItemAction";

export function ProductExpireDateListItem(props: {
  productExpireBatch: any;
  onPress: (id: string) => void;
  isLast?: boolean;
}) {
  const batch = useFragment(
    graphql`
      fragment ProductExpireDateListItem_StoreProductExpireBatch on StoreProductExpireBatch {
        activeAction {
          ...ProductExpireBatchListItemAction_StoreProductExpireBatchAction
        }
        expireAtDate {
          isoString
        }
      }
    `,
    props.productExpireBatch
  );
  const intl_tokens = useIntlTokens();
  return (
    <ListItem
      isLast={props.isLast}
      onPress={() => {
        props.onPress(batch.id);
      }}
    >
      <AHText
        type="subtitle"
        color={batch.status === "INACTIVE" ? "text-washed" : "text-secondary"}
        style={{ flex: 1 }}
      >
        {intl_tokens.ExpireDate}{" "}
        {DateTime.fromISO(batch.expireAtDate.isoString).toFormat("dd-MM-yyyy")}
      </AHText>
      {batch.activeAction ? (
        <ProductExpireBatchListItemAction
          key={batch.id}
          productExpireBatchAction={batch.activeAction}
        />
      ) : null}
    </ListItem>
  );
}
